document.addEventListener("DOMContentLoaded", function () {
  /* =========================================================
     OPTION A — auto label + auto size
  ========================================================= */
  function labelFromName(name) {
    if (!name) return "Untitled Asset";
    return (
      name
        .split("?")[0]
        .replace(/\.[^.]+$/, "") // drop extension
        .replace(/_[0-9a-f]{8,}$/i, "") // drop Shopify hash suffix
        .replace(/[-_]+/g, " ") // tidy separators
        .trim() || "Untitled Asset"
    );
  }

  function formatBytes(bytes) {
    if (!bytes || isNaN(bytes)) return "";
    return bytes >= 1048576
      ? (bytes / 1048576).toFixed(2) + " MB"
      : (bytes / 1024).toFixed(2) + " KB";
  }

  async function fetchSize(url) {
    try {
      const res = await fetch(url, { method: "HEAD" });
      return formatBytes(Number(res.headers.get("content-length")));
    } catch (e) {
      return "";
    }
  }

  /* Fill labels immediately for every row */
  document.querySelectorAll(".pk-file-row").forEach((row) => {
    const chk = row.querySelector(".pk-download-check");
    const nameEl = row.querySelector(".pk-file-name");
    if (chk && nameEl && !nameEl.textContent.trim()) {
      nameEl.textContent = labelFromName(chk.dataset.name);
    }
  });

  /* Fill sizes lazily, once, when a card's panel first opens */
  function hydrateSizes(card) {
    if (!card || card.dataset.sizesDone) return;
    card.dataset.sizesDone = "1";
    card.querySelectorAll(".pk-file-row").forEach(async (row) => {
      const chk = row.querySelector(".pk-download-check");
      const sizeEl = row.querySelector(".pk-file-size");
      if (!chk || !sizeEl || sizeEl.textContent.trim()) return;
      const size = await fetchSize(chk.dataset.url);
      sizeEl.textContent = size ? "(" + size + ")" : "";
    });
  }

  /* =========================================================
     Selected-count helpers
  ========================================================= */
  function updateSelectedCount(panel) {
    const activeTabContent = panel.querySelector(".pk-content.active");
    if (!activeTabContent) return;
    const count = activeTabContent.querySelectorAll(
      ".pk-download-check:checked",
    ).length;
    const label = panel.querySelector(".pk-download-label");
    if (!label) return;
    label.textContent = count
      ? `Download Selected (${count})`
      : "Download Selected";
  }

  function resetCounts() {
    document.querySelectorAll(".pk-panel").forEach((panel) => {
      updateSelectedCount(panel);
    });
  }

  /* =========================================================
     Shared download helpers (fetch -> blob -> save / zip)
  ========================================================= */
  let jsZipPromise;
  function loadJSZip() {
    if (window.JSZip) return Promise.resolve(window.JSZip);
    if (!jsZipPromise) {
      jsZipPromise = new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src =
          "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
        s.onload = () => resolve(window.JSZip);
        s.onerror = () => reject(new Error("Failed to load JSZip"));
        document.head.appendChild(s);
      });
    }
    return jsZipPromise;
  }

  function triggerBlobDownload(blob, filename) {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  }

  // Single raw file — fetched so the correct filename is preserved
  async function downloadSingle(item) {
    const res = await fetch(item.url);
    if (!res.ok) throw new Error("HTTP " + res.status);
    const blob = await res.blob();
    triggerBlobDownload(blob, item.name);
  }

  // Multiple files -> one zip. Items: {url, name, folder?}
  async function fetchToZip(items, zipName) {
    const JSZip = await loadJSZip();
    const zip = new JSZip();
    const used = {};
    let ok = 0;

    await Promise.all(
      items.map(async (item) => {
        try {
          const res = await fetch(item.url);
          if (!res.ok) throw new Error("HTTP " + res.status);
          const blob = await res.blob();

          const folder = item.folder || "";
          const key = folder + "/" + item.name;

          // guard against duplicate names within the same folder
          let name = item.name;
          if (used[key]) {
            const dot = item.name.lastIndexOf(".");
            const base = dot > 0 ? item.name.slice(0, dot) : item.name;
            const ext = dot > 0 ? item.name.slice(dot) : "";
            name = base + "-" + used[key] + ext;
          }
          used[key] = (used[key] || 0) + 1;

          (folder ? zip.folder(folder) : zip).file(name, blob);
          ok++;
        } catch (e) {
          console.warn("Skipped:", item.name, e);
        }
      }),
    );

    if (!ok) throw new Error("No files could be fetched");

    // STORE = no compression; media is already compressed, so this is faster
    const blob = await zip.generateAsync({
      type: "blob",
      compression: "STORE",
    });
    triggerBlobDownload(blob, zipName);
  }

  function productSlug(card) {
    return (card.querySelector(".pk-custom-img")?.alt || "press-kit")
      .trim()
      .replace(/\s+/g, "-");
  }

  /* =========================================================
     Accordion (+ hydrateSizes on open)
  ========================================================= */
  document.querySelectorAll(".preview-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const card = this.closest(".pk-card");
      const current = card.querySelector(".pk-panel");
      const open = current.classList.contains("active");

      document.querySelectorAll(".pk-panel.active").forEach((p) => {
        p.classList.remove("active");
      });

      if (open) {
        setTimeout(() => {
          const section = document.querySelector(".press-kit");
          if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 300);
        return;
      }

      current.classList.add("active");
      hydrateSizes(card);
      updateSelectedCount(current);

      setTimeout(() => {
        const downloadBtn = current.querySelector(".pk-download-selected");
        if (!downloadBtn) return;
        const rect = downloadBtn.getBoundingClientRect();
        const targetGap = 20;
        const moveAmount = rect.bottom - (window.innerHeight - targetGap);
        window.scrollBy({ top: moveAmount, behavior: "smooth" });
      }, 300);
    });
  });

  /* =========================================================
     Tabs
  ========================================================= */
  document.querySelectorAll(".pk-tabs button").forEach((tab) => {
    tab.addEventListener("click", function () {
      const panel = this.closest(".pk-panel");
      panel.querySelectorAll(".pk-tabs button").forEach((b) => {
        b.classList.remove("active");
      });
      this.classList.add("active");
      panel.querySelectorAll(".pk-content").forEach((c) => {
        c.classList.remove("active");
      });
      panel
        .querySelector(`[data-content="${this.dataset.tab}"]`)
        .classList.add("active");
      updateSelectedCount(panel);
    });
  });

  /* =========================================================
     Checkbox count update
  ========================================================= */
  document.querySelectorAll(".pk-download-check").forEach((check) => {
    check.addEventListener("change", function () {
      const panel = this.closest(".pk-panel");
      updateSelectedCount(panel);
    });
  });

  /* =========================================================
     Download SELECTED — 1 file = raw download, 2+ = one zip
  ========================================================= */
  const TAB_FOLDERS = { media: "Media", spec: "Spec Sheet", press: "Press Meet" };
  const TAB_SLUGS = { media: "Media", spec: "Spec-Sheet", press: "Press-Meet" };

  document.querySelectorAll(".pk-download-selected").forEach((btn) => {
    btn.addEventListener("click", async function () {
      if (this.disabled) return;

      const panel = this.closest(".pk-panel");
      const activeContent = panel.querySelector(".pk-content.active");
      const checked = activeContent.querySelectorAll(
        ".pk-download-check:checked",
      );
      if (!checked.length) return;

      const items = Array.from(checked).map((c) => ({
        url: c.dataset.url,
        name: c.dataset.name || "download",
      }));

      const button = this;
      const labelEl = button.querySelector(".pk-download-label");
      const original = labelEl ? labelEl.textContent : button.textContent;
      const setLabel = (t) => {
        if (labelEl) labelEl.textContent = t;
        else button.textContent = t;
      };

      button.disabled = true;
      button.classList.add("is-loading");

      try {
        if (items.length === 1) {
          setLabel("Downloading...");
          await downloadSingle(items[0]);
        } else {
          setLabel("Preparing ZIP...");
          const tabSlug = TAB_SLUGS[activeContent.dataset.content] || "Selected";
          const zipName =
            productSlug(panel.closest(".pk-card")) +
            "-" +
            tabSlug +
            "-selected.zip";
          await fetchToZip(items, zipName);
        }
      } catch (e) {
        console.error(e);
        alert("Sorry, the download couldn't be prepared. Please try again.");
      } finally {
        button.disabled = false;
        button.classList.remove("is-loading");
        if (labelEl) updateSelectedCount(panel);
        else button.textContent = original;
      }
    });
  });

  /* =========================================================
     Download ALL — every file across the 3 tabs -> one zip
  ========================================================= */
  document.querySelectorAll(".download-all-btn").forEach((btn) => {
    btn.addEventListener("click", async function () {
      if (this.disabled) return;

      const card = this.closest(".pk-card");
      const items = [];
      card.querySelectorAll(".pk-content").forEach((content) => {
        const folder = TAB_FOLDERS[content.dataset.content] || "Files";
        content.querySelectorAll(".pk-download-check").forEach((chk) => {
          if (chk.dataset.url) {
            items.push({
              url: chk.dataset.url,
              name: chk.dataset.name || "file",
              folder: folder,
            });
          }
        });
      });
      if (!items.length) return;

      const button = this;
      const originalHTML = button.innerHTML;
      button.disabled = true;
      button.classList.add("is-loading");
      button.innerHTML = "Preparing ZIP...";

      try {
        await fetchToZip(items, productSlug(card) + "-assets.zip");
      } catch (e) {
        console.error(e);
        alert("Sorry, the download couldn't be prepared. Please try again.");
      } finally {
        button.disabled = false;
        button.classList.remove("is-loading");
        button.innerHTML = originalHTML;
      }
    });
  });

  /* =========================================================
     LIGHTBOX — click a row to preview (uses smaller preview url + spinner)
  ========================================================= */
  const lightbox = document.querySelector(".pk-lightbox");

  function fileTypeFromUrl(url) {
    const clean = url.split("?")[0].toLowerCase();
    if (/\.(mp4|mov|webm|m4v|ogv)$/.test(clean)) return "video";
    if (/\.(png|jpe?g|gif|webp|avif|svg)$/.test(clean)) return "image";
    if (/\.pdf$/.test(clean)) return "pdf";
    return "other";
  }

  function openLightbox(url, type) {
    if (!lightbox) return;
    const body = lightbox.querySelector(".pk-lightbox-body");
    body.innerHTML = '<div class="pk-lightbox-spinner"></div>';
    lightbox.classList.add("is-loading"); // hides the close button until ready
    const spinner = body.firstChild;
    const clearSpinner = () => {
      if (spinner && spinner.parentNode) spinner.remove();
      lightbox.classList.remove("is-loading");
    };

    if (type === "image") {
      const img = document.createElement("img");
      img.alt = "";
      img.style.display = "none";
      img.onload = () => {
        clearSpinner();
        img.style.display = "block";
      };
      img.onerror = clearSpinner;
      img.src = url;
      body.appendChild(img);
    } else if (type === "video") {
      const v = document.createElement("video");
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      v.style.display = "none";
      v.onloadeddata = () => {
        clearSpinner();
        v.style.display = "block";
      };
      v.onerror = clearSpinner;
      v.src = url;
      body.appendChild(v);
    } else if (type === "pdf") {
      const iframe = document.createElement("iframe");
      iframe.className = "pk-lightbox-pdf";
      iframe.onload = clearSpinner;
      iframe.src = url;
      body.appendChild(iframe);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener";
      link.className = "pk-lightbox-openlink";
      link.textContent = "Open PDF in new tab";
      body.appendChild(link);
    } else {
      clearSpinner();
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener";
      link.className = "pk-lightbox-openlink";
      link.textContent = "Open file";
      body.appendChild(link);
    }

    lightbox.classList.add("active");
    lightbox.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.querySelector(".pk-lightbox-body").innerHTML = ""; // stops video
    lightbox.classList.remove("active", "is-loading");
    lightbox.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  document.querySelectorAll(".pk-file-info").forEach((info) => {
    info.style.cursor = "pointer";
    info.addEventListener("click", function () {
      const row = this.closest(".pk-file-row");
      const chk = row && row.querySelector(".pk-download-check");
      if (!chk) return;
      const url = chk.dataset.preview || chk.dataset.url;
      if (!url) return;
      openLightbox(url, fileTypeFromUrl(url));
    });
  });

  if (lightbox) {
    lightbox
      .querySelector(".pk-lightbox-close")
      .addEventListener("click", closeLightbox);
    lightbox
      .querySelector(".pk-lightbox-overlay")
      .addEventListener("click", closeLightbox);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeLightbox();
    });
  }

  resetCounts();
});